<template>
  <ParseForm :formParams='formParams' :formId="formId" :reMountPage='reMountPage' ref='bus' :opCode='opCode' :funcOnChange="changeFleetWithTypeOut" :funcKeyUp="funcKeyUp"></ParseForm>
</template>

<script>
import Vue from 'vue';
import ParseForm from '../../util/parseFormNew/ParseForm';

const bus = new Vue();

export default {
  name: 'U_BaseBusiness',
  components: {
    ParseForm
  },
  props: [
    'formParams',
    'reMountPage',
    'dialPlan',
    'opCode',
    'formId',
    'funcKeyUp'
  ],
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    setSelectOptions(name, options) {
      this.$refs.bus.setAttrByName(name, 'options', options);
    },
    setData(name, value) {
      this.$refs.bus.setData(name, value);
    },
    setDatas(value) {
      this.$refs.bus.setDatas(value);
    },
    getAttrByName(_name, _type) {
      return this.$refs.bus.getAttrByName(_name, _type);
    },
    // 设置表单验证
    setValidate(_name, _validate) {
      this.$refs.bus.setValidate(_name, _validate);
    },
    removeValidate(name) {
      this.$refs.bus.removeValidate(name);
    },
    changeFleetWithTypeInner() {
      try {
        if (this.fleetListDataNormal.length === 0) {
          const fleetOptions = [];
          for (let index = 20; index <= 89; index++) {
            fleetOptions.push({ showName: index, value: index });
          }
          this.fleetListDataNormal = fleetOptions;
        }
        const newValue = this.$refs.bus.getAttrByName('grptype', 'value');
        if (newValue === 4) {
          this.$refs.bus.setAttrByName('grpnum[fleet]', 'options', this.fleetListData);
          this.$refs.bus.setData('grpnum[fleet]', this.fleetListData[0].value);
        } else {
          this.$refs.bus.setAttrByName('grpnum[fleet]', 'options', this.fleetListDataNormal);
          this.$refs.bus.setData('grpnum[fleet]', this.fleetListDataNormal[0].value);
        }

        const _dialPlan = this.dialPlan;
        if(_dialPlan === 5){//P3
          if(newValue === 4)
          {
            const validate ={range:[[0,999],this.$t('SubscriberIms.noZoneDial6Tip')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
            this.$refs.bus.setValidate('grpnum[number]',validate);
            this.$refs.bus.setAttrByName('grpnum[number]','placeholder', '000~999');
            this.$refs.bus.setValidate('grpnum[startNo]',validate);
            this.$refs.bus.setAttrByName('grpnum[startNo]','placeholder', '000~999');
            this.$refs.bus.setValidate('grpnum[endNo]',validate);
            this.$refs.bus.setAttrByName('grpnum[endNo]','placeholder', '000~999');
          }
          else{
            const validate ={range:[[900,999],this.$t('SubscriberIms.noZoneDial1Tip')],rangeLength:[[3,3],this.$t('SubscriberIms.solid_3')]};
            this.$refs.bus.setValidate('grpnum[number]',validate);
            this.$refs.bus.setAttrByName('grpnum[number]','placeholder', '900~999');
            this.$refs.bus.setValidate('grpnum[startNo]',validate);
            this.$refs.bus.setAttrByName('grpnum[startNo]','placeholder', '900~999');
            this.$refs.bus.setValidate('grpnum[endNo]',validate);
            this.$refs.bus.setAttrByName('grpnum[endNo]','placeholder', '900~999');
          }
        }
      } catch(e) {
        console.log('异常了', e);
      }
    },
    checkDmrZone(zone)
    {
      if(zone === '00' ||
        zone === '10' ||
        zone === '20' ||
        zone === '30' ||
        zone === '40' ||
        zone === '50' ||
        zone === '60' ||
        zone === '70' ||
        zone === '80' ||
        zone === '90' ){
        return true;
      }
    },
    changeNumWithZone(){
      const _dialPlan = this.dialPlan;
      if(_dialPlan === 4){//DMR
        const map = this.getDatas();
        const returnObj = {};
        Array.from(map).forEach(([key, value]) => {
          returnObj[key] = value;
        });
        if(this.checkDmrZone(returnObj['grpnum[zone]']))
        {
          const validate ={range:[[1,99999],this.$t('SubscriberIms.numDialTip7')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
          this.$refs.bus.setValidate('grpnum[number]',validate);
          this.$refs.bus.setAttrByName('grpnum[number]','placeholder', '00001~99999');
          this.$refs.bus.setValidate('grpnum[startNo]',validate);
          this.$refs.bus.setAttrByName('grpnum[startNo]','placeholder', '00001~99999');
          this.$refs.bus.setValidate('grpnum[endNo]',validate);
          this.$refs.bus.setAttrByName('grpnum[endNo]','placeholder', '00001~99999');
        }
        else{
          const validate ={range:[[0,99999],this.$t('SubscriberIms.numDialTip2')],rangeLength:[[5,5],this.$t('SubscriberIms.solid_5')]};
          this.$refs.bus.setValidate('grpnum[number]',validate);
          this.$refs.bus.setAttrByName('grpnum[number]','placeholder', '00000~99999');
          this.$refs.bus.setValidate('grpnum[startNo]',validate);
          this.$refs.bus.setAttrByName('grpnum[startNo]','placeholder', '00000~99999');
          this.$refs.bus.setValidate('grpnum[endNo]',validate);
          this.$refs.bus.setAttrByName('grpnum[endNo]','placeholder', '00000~99999');
        }
      }
    }
  },
  mounted() {
    bus.$on('eventBus', (attr) => {
      try {
        this.$refs.bus.templetCover(attr);
      } catch (e) {
      }
    });
  },
  data() {
    return {
      fleetListData: [
        { showName: 90, value: 90 }, { showName: 97, value: 97 }, { showName: 98, value: 98 }, { showName: 99, value: 99 }
      ],
      fleetListDataNormal: [],
      funcMap: ''
    };
  },
  computed: {
    changeFleetWithTypeOut() {
      if (this.opCode === 'mod' || this.opCode === 'batchMod') {
        return undefined;
      }
      this.funcMap = new Map();
      this.funcMap.set('grptype', this.changeFleetWithTypeInner);
      this.funcMap.set("grpnum[zone]",this.changeNumWithZone);
      return this.funcMap;
    }
  }
};
</script>

<style scoped>

</style>
